<template>
  <Modal v-model="showpick" scrollable :title="il8Title" width="1024px" @on-cancel="$_cancel" :styles="modalStyle">
    <div class="emap-flow-pick">
      <div class="emap-flow-search">
        <Input 
          type="text" 
          v-model.trim="searchkey" 
          :placeholder="il8Placeholder"
          :enter-button="$LocalH5('search')" 
          @on-search="$_search" 
          search/>
      </div>
      <div class="emap-flow-main clearfix">
        <!--  组织机构 -->
        <div class="emap-flow-left">
          <Tabs value="tabX" :animated="false">
            <TabPane :label="$LocalH5('organization')" name="tabX">
              <Tree
                ref="tree" 
                :data="treeData"
                :empty-text="$LocalH5('noData')"
                @on-select-change="$_treeItemCheck"
                @on-check-change="$_filterItemCheck"
                :show-checkbox="filter&&multiple"
                class="emap-flow-left-tree">
              </Tree>
            </TabPane>
          </Tabs>
        </div>
        <!-- 获取的人员列表 -->
        <div class="emap-flow-center">
          <div class="emap-flow-center-header">
            <span>{{$LocalH5('waitPersonnel')}}</span>
            <span class="emap-flow-center-count">{{staff.length}}</span>
          </div>
          <div class="emap-flow-nodata" v-if="!staff.length">{{$LocalH5('noData')}}</div>
          <div class="emap-flow-center-body"  v-if="staff.length">
            <table style="width: 100%;">
              <thead>
                <tr style="height: 30px;">
                  <th class="emap-flow-col1" style="text-align: center">
                    <Checkbox v-model="isCheckedAll" v-if="multiple" style="margin-right: 4px;" :disabled="!staff.length" @on-change="$_allCheck"></Checkbox>
                  </th>
                  <th class="emap-flow-col3">{{$LocalH5('name')}}</th>
                  <th class="emap-flow-col3">{{$LocalH5('numId')}}</th>
                  <th class="emap-flow-col3">{{$LocalH5('org')}}</th>
                </tr>
              </thead>
            </table>
            <!-- 单选 -->
            <div class="emap-flow-radio-list" v-if="!multiple">
              <RadioGroup v-model="raidoValue" style="width:100%" vertical>
                <Radio v-for="item in staff" :key="item.id" :label="item.id" class="emap-flow-radio-item">
                  <span class="emap-flow-col3" :title="item.name">{{item.name}}</span>
                  <span class="emap-flow-col3" :title="item.encodeId">{{item.encodeId}}</span>
                  <span class="emap-flow-col3" :title="item.deptName">{{item.deptName}}</span>
                </Radio>
              </RadioGroup>
            </div>
            <!-- 多选 -->
            <div class="emap-flow-checkbox-list" v-if="multiple">
              <CheckboxGroup v-model="checkboxValue">
                <Checkbox  
                  v-for="item in staff" 
                  :key="item.id" 
                  :label="item.id" 
                  class="emap-flow-checkbox-item" 
                  @input="$_checkboxItemCheck(item)" 
                  :disabled="disabledOptions.indexOf(item.id)>-1">
                  <span class="emap-flow-col3" :title="item.name">{{item.name}}</span>
                  <span class="emap-flow-col3" :title="item.encodeId">{{item.encodeId}}</span>
                  <span class="emap-flow-col3" :title="item.deptName">{{item.deptName}}</span>
                </Checkbox>
              </CheckboxGroup>
            </div>
            <Page :current="pageNumber" :total="total" simple class="emap-flow-page" @on-change="$_pageChange"/>
          </div>
        </div>
        <!-- 选中人员列表 -->
        <div class="emap-flow-right">
          <div class="emap-flow-right-header">
            <span>{{$LocalH5('selectedPersonnel')}}</span>
            <span class="emap-flow-right-count">{{checkedStaff.length}}</span>
          </div>
          <div class="emap-flow-right-body" v-if="checkedStaff.length">
            <table style="width: 100%;">
              <thead>
                <tr style="height: 30px;">
                   <th class="emap-flow-col3">{{$LocalH5('name')}}</th>
                  <th class="emap-flow-col3">{{$LocalH5('numId')}}</th>
                  <th class="emap-flow-col3">{{$LocalH5('org')}}</th>
                  <th class="emap-flow-col1">{{$LocalH5('delete')}}</th>
                </tr>
              </thead>
            </table>
            <div class="emap-flow-checked-list">
              <div class="emap-flow-checked-item clearfix" v-for="(item, index) in checkedStaff" :key="index" :class="[{'emap-flow-disabled': disabledOptions.indexOf(item.id)>-1}]">
                <span class="emap-flow-col3" :title="item.name || item.userName">{{item.name || item.userName}}</span>
                <span class="emap-flow-col3" :title="item.encodeId || item.userId">{{item.encodeId  || item.userId}}</span>
                <span class="emap-flow-col3" :title="item.deptName">{{item.deptName}}</span>
                <span class="emap-flow-col1" @click.stop="$_deleteRecords(item,index, disabledOptions.indexOf(item.id)>-1)"><Icon type="md-trash" size="16"/></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button size="large" @click="$_cancel">{{$LocalH5('buttonCancel')}}</Button>
      <Button type="primary" size="large" @click="$_confirm">{{$LocalH5('buttonConfirm')}}</Button>
    </div>
  </Modal>

</template>
<script>
  import api from '@/api'
  import { encode18bit }  from 'utils'
  import { getCookie, getURLParamH5 } from '../../lang/cookie'
  export default {
    name: "emap-flow-pick",
    props: {
      value: Boolean,
      title: {
        type: String,
        default:'选择人员'
      },
      placeholder: {
        type: String,
        default: "输入姓名/工号"
      },
      multiple: Boolean,
      disabledOptions: {
        type: Array,
        default: function() {
          return []
        }
      }, // 仅用于多选
      options: [Array,String],
      contextPath: String,
      users: {
        type: Array,
        default: function() {
          return []
        }
      },
      filter: Boolean
    },
    computed:{
      il8Title(){
        return this.title==='选择人员' ? this.$LocalH5('selectMember'):this.title
      },
      il8Placeholder(){
        return this.placeholder === '输入姓名/工号' ? this.$LocalH5('searchPlaceholder') : this.placeholder
      },
    },
    data() {
      return {
        modalStyle: {"top": "100px"},
        showpick: this.value,
        searchkey: "",
        treeData: [],
        staff: [],
        raidoValue: '',
        isCheckedAll: false,
        checkboxValue: [],
        checkedStaff: [],
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        departId: null,
        isSearch: false,   // 用于标识当前选人组件是否为搜索状态，默认false
        searchSourceData: [], // filter模式下搜索源数据
        langKey:"zh"
      }
    },
    watch: {
      value: function(val) {
        if(val) {
          this.initialize();
          this.queryDepartTree();
        } 
        this.showpick = val;
      },
      raidoValue: function(key) {
        this.checkedStaff = this.staff.filter(item => {
          return item.id === key
        });
      }
    },
    methods: {
      $_cancel() {
        this.$emit('input',false);
        this.$emit('on-cancel', this.raidoValue, this.checkedStaff)
      },
      $_confirm() {
        if(this.checkedStaff.length) {
          this.showpick = false;
          this.$emit('input',false);
          if(this.filter) {
            let values = this.checkedStaff.map(item => item.userId);
            this.$emit('on-confirm', values, this.checkedStaff);
          } else {
            if(this.multiple) {
              this.$emit('on-confirm', this.checkboxValue, this.checkedStaff)
            } else {
              this.$emit('on-confirm', this.raidoValue, this.checkedStaff)
            }
          }
        } else {
          this.$Message.warning(this.$LocalH5('validSeleMember'));
        }
      },
      $_search(value) {
        // this.isSearch = !!value;
        // 更改为点击搜索则为搜索模式
        this.isSearch = true
        if(this.filter) {
          // let result = this.searchSourceData.filter(item => !item.children && item.title.indexOf(value) > -1);
          console.log(value)
        } else {
          this.pageNumber = 1;
          this.queryDeptStaff();
        }
      },
      $_allCheck(value) {
        if(value) {
          this.staff.forEach(item => {
            if(this.disabledOptions.indexOf(item.id) === -1 && this.checkboxValue.indexOf(item.id) == -1) {
              this.checkboxValue.push(item.id);
              this.checkedStaff.push(item);
            }
          });
        } else {
          var staffId = [];
          this.staff.forEach(item => {
            var index = this.checkboxValue.indexOf(item.id);
            if(this.disabledOptions.indexOf(item.id) == -1){
              if(index > -1) this.checkboxValue.splice(index,1);
              staffId.push(item.id);
            }
          });
          this.checkedStaff = this.checkedStaff.filter(item => {
            return staffId.indexOf(item.id) == -1;
          });
        }
      },
      $_filterItemCheck(items) {
        this.checkedStaff = items.filter(item => !item.children);
      },
      $_treeItemCheck(item) {
        if(this.filter) {
          if(!this.multiple) {
            this.checkedStaff = item.filter(item => !item.children);
          }
        } else {
          // 点击左侧则清空搜索词
          this.searchkey = ""
          if(item && item.length){
            // 取消时不做处理，选中才请求数据
            this.pageNumber = 1;
            this.isSearch = false;
            this.queryDeptStaff(item[0].DM);
          }
        }
      },
      $_pageChange(index) {
        this.pageNumber = index; 
        this.queryDeptStaff();
      },
      $_deleteRecords(item,index,isdisabled) {
        if(isdisabled) return;
        this.checkedStaff.splice(index,1);
        if(this.filter) {
          this.updateLeftTree(item);
        } else {
          this.updateCenterValue();
        }
      },
      $_checkboxItemCheck(item) {
        const checked = !(this.checkboxValue.indexOf(item.id) > -1);
        if(checked) {
          this.checkedStaff.push(item);
          // 联动全选按钮
          this.isCheckedAll = true;
          this.staff.forEach(obj => {
            if(obj.id !== item.id && this.checkboxValue.indexOf(obj.id) === -1) {
              this.isCheckedAll = false
            }
          })
        } else {
          this.checkedStaff = this.checkedStaff.filter(obj => {
            return obj.id !== item.id
          });
          this.isCheckedAll = false;
        }
      },
      updateLeftTree(node) {
        const vmtree = this.$refs.tree;
        if(this.multiple) {
          vmtree.$set(node, 'checked', false);
          vmtree.$set(node, 'indeterminate', false);

          vmtree.updateTreeUp(node.nodeKey);
          vmtree.updateTreeDown(node, {checked: false, indeterminate: false});
        } else {
          vmtree.$set(node, 'selected', false);
        }
      },
      updateCenterValue() {
        if(this.multiple) {
          this.isCheckedAll = false;
          this.checkboxValue = this.checkedStaff.map(item =>{
            return item.id
          })
        } else {
          this.raidoValue = ""
        }
      },
      initialize() {
        this.searchkey = "";
        this.treeData = [];
        this.staff = [];
        this.checkedStaff = [];
        this.isCheckedAll = false;
        this.pageNumber = 1;
        this.pageSize = 10;
        this.total = 0;
        this.departId = null;
        this.isSearch = false;
        this.checkedStaff = [];
        this.rectifyModalPostion();
        if(this.filter) {
          this.searchSourceData = [];
        } else {
          this.queryCheckedStaff();
        }
      },
      rectifyModalPostion() {
        if(window.innerHeight < 567) {
          this.modalStyle.top = 0
        }else if (767 > window.innerHeight && window.innerHeight > 567) {
          this.modalStyle.top = parseInt((window.innerHeight-567)/2) + 'px';
        }
      },
      queryDepartTree() {
        api.getDeptQuery().then(data => {
          if (data.code == '0' && data.datas) {
            const datas = data.datas;
            datas.deptQuery.rows = datas.deptQuery.rows.map(row =>{
              row.title = this.langKey==='zh'? row.MC: (row.ywmc||row.MC);
              row.selected = false;
              return row
            });
            if (datas.deptQuery && datas.deptQuery.rows) {
              if(this.filter) {
                let hashArr = new Array();
                datas.deptQuery.rows.forEach(item => {
                  hashArr[item.DM] = item; 
                })
                let filterData = [], filterIds = [];
                this.users.forEach(user => {
                  filterIds.push(user.userId)
                  if(user.deptId) {
                    if(filterIds.indexOf(user.deptId) == -1) {
                      filterIds.push(user.deptId);
                    }
                    user.LS = user.deptId;
                    user.DM = user.userId;
                    user.title = user.userName;
                  } else {
                    user.LS = null;
                    user.DM = user.userId;
                    user.title = user.userName;
                  }
                  delete user.checked;
                  delete user.selected;
                  if(this.multiple && this.options.indexOf(user.userId) > -1) {
                    user.checked = true;
                  }
                  if(!this.multiple && this.options.indexOf(user.userId) > -1) {
                    user.selected = true;
                  }
                  hashArr[user.userId] = user;
                })
                let temp = [];
                filterIds.forEach(id => {
                  if(id) {
                    let tempItem = hashArr[id];
                    if(temp.indexOf(tempItem.DM) == -1) {
                      filterData.push(tempItem);
                      while(tempItem.LS && temp.indexOf(hashArr[tempItem.LS].DM) == -1) {
                        tempItem = hashArr[tempItem.LS];
                        temp.push(tempItem.DM);
                        filterData.push(tempItem);
                      }
                    }
                  }
                });
                this.searchSourceData = filterData;
                this.treeData = this.toTreeData(filterData, null, {
                  ukey: "DM",
                  pkey: 'LS',
                  toCKey: 'children'
                });

                // 赋值
                this.$nextTick(() => {
                  this.checkedStaff = this.$refs.tree.getCheckedNodes().filter(item => !item.children);
                })
              } else {
                this.treeData = this.toTreeData(datas.deptQuery.rows, null, {
                  ukey: "DM",
                  pkey: 'LS',
                  toCKey: 'children'
                });
                if(this.treeData && this.treeData.length) {
                  this.treeData[0].selected = true;
                  this.queryDeptStaff(this.treeData[0].DM);
                }
              }
            }
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      // 清空左侧选中的状态（仅限于树组件单选情况下）
      emptyOptions(data) {
          data.some((item) => {
            if (item.selected) {
              item.selected = false
              return true
            }else{
              if (item.children && item.children.length > 0) {
                this.emptyOptions(item.children)
              }
            }
          })
       },
      queryDeptStaff(id) {
        if(id !== undefined) {
          this.departId = id;
        }
        let params = this.isSearch?
          {
            // NAME: this.searchkey, // 测试时候的搜索词
            pageNumber: this.pageNumber,
            pageSize: this.pageSize
          }:{
            SZDWDM: this.departId, // 点击左侧组织时候（非搜索）
            pageNumber: this.pageNumber,
            pageSize: this.pageSize
          };
        if(this.isSearch){
          // 搜索则清空选中状态
          this.emptyOptions(this.treeData)
          if(this.searchkey){
            params = Object.assign({NAME: this.searchkey},params)
          }
        }
        api.getDeptStaff(params).then(data => {
          if (data.code == '0' && data.datas) {
            const datas = data.datas;
            if (datas.jzgQuery && datas.jzgQuery.rows) {
              this.staff = datas.jzgQuery.rows.map(row => {
                row.id = row.ZGH;
                row.encodeId = encode18bit(row.ZGH);
                row.name = row.XM;
                row.deptName = this.langKey === 'zh'? row.MC: (row.ywmc||row.MC);
                row.departId = row.SZDWDM;
                return row;
              });
              this.total = datas.jzgQuery.totalSize;
              if(this.multiple) {
                this.isCheckedAll = !!this.staff.length;
                this.staff.forEach(item => {
                  if(this.checkboxValue.indexOf(item.id) == -1) this.isCheckedAll = false;
                })
              }
            }
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      queryCheckedStaff() {
        if(this.multiple) {
          this.checkboxValue = (this.options || []).concat(this.disabledOptions);
          if(!this.checkboxValue.length) {
            this.checkedStaff = [];
            return
          }
        } else {
          this.raidoValue = this.options;
          if(!this.raidoValue) {
            this.checkedStaff = [];
            return
          }
        }
        let params = {
          zghs: typeof this.options === "string"?this.options:JSON.stringify(this.options.concat(this.disabledOptions)),
          pageNumber: 1,
          pageSize: 10
        };
        api.getSearchStaff(params).then(data => {
          if (data.code == '0' && data.datas) {
            const datas = data.datas;
            if (datas.jzgQuery && datas.jzgQuery.rows) {
              this.checkedStaff = datas.jzgQuery.rows.map( row => {
                row.id = row.ZGH;
                row.encodeId = encode18bit(row.ZGH);
                row.name = row.XM;
                row.deptName = row.MC;
                row.departId = row.SZDWDM;
                return row;
              });
            }
          } else {
            this.$Message.error(data.msg);
          }
        });
      },
      toTreeData(data, parent_id, options, checked) {
        let opt = options || { ukey:"id", pkey:'parent_id', toCKey:'children' };

        // 校验树的源数据，消除源数据 id == parent_id 引起的死循环
        checked = checked || false;
        if(!checked) {
          data = data.map((item,index) => {
            if(item[opt.ukey] === item[opt.pkey]) {
              console.error("第" + (index + 1) + "数据不符合要求：", item);
              item[opt.pkey] = parent_id;
            }
            return item;
          })
          checked = true;
        }
        
        let tree = [];
        let temp;
        for (var i = 0; i < data.length; i++) {
          if (data[i][opt.pkey] == parent_id || data[i][opt.ukey] === data[i][opt.pkey]) {
            var obj = data[i];
            temp = this.toTreeData(data, data[i][opt.ukey], opt, checked);
            if (temp.length > 0) {
              obj[opt.toCKey] = temp;
            }
            tree.push(obj);
          }
        }
        return tree;
      },
      filterTreeData(source, filter) {
        let temp;
        for(let i = 0, len = source.children.length; i<len; i++) {
          if (filter.indexOf(source.children[i]["DM"]) > -1) {
            if(source.children[i].children) {
              delete source.children[i].children
            }
            temp = source;
            break;
          } else if (source.children[i].children && source.children[i].children.length) {
            let tempChild = this.filterTreeData(source.children[i], filter);
            if(tempChild) {
              source.children[0].children[0] = tempChild;
              temp = source;
            }
          }
        }
        return temp
      },
    },
    mounted() {
      this.langKey = getCookie('EMAP_LANG') || getURLParamH5('EMAP_LANG') || 'zh'
      // TODO
    }
  }
</script>
<style>
  .clearfix:before, .clearfix:after {
    content: '';
    display: table;
    clear: both;
  }
  .clearfix {
    zoom:1
  }
  .emap-flow-pick {
    font-size: 12px;
  }
  .emap-flow-search {
    width: 50%;
    padding-bottom: 10px;
  }
  .emap-flow-main {
    width: 100%;
    height: 380px;
    background: #F7F8FC;
    border: 1px solid #D8DCF0;
  }
  .emap-flow-main>div {
    position: relative;
    float: left;
    width: 33.33%;
    height: 100%;
  }
  .emap-flow-left-tree {
    height: 305px; 
    width: 100%; 
    overflow: auto;
  }
  .emap-flow-left-tree .ivu-tree-children::after, .emap-flow-left-tree .ivu-tree-children::before {
    display: table;
    content: '';
    clear: both;
  }
  .emap-flow-left-tree  ul li {
    margin: 2px 0 2px 0;
  }
  .emap-flow-center, .emap-flow-right {
    border-left: 1px solid #e8e0eb;
  }
  .emap-flow-center:before,.emap-flow-center:after,.emap-flow-right:before,.emap-flow-right:after {
    width: 0;
    height: 0;
    content: ' ';
    position: absolute;
    z-index: -1;
  }
  .emap-flow-center:before, .emap-flow-right:before {
    border: 44px solid transparent;
    border-left: 14px solid #e8e0eb;
    top: 128px;
    left: 0;
  }
  .emap-flow-center:after,.emap-flow-right:after {
    border: 44px solid transparent;
    border-left: 14px solid #F7F8FC;
    top: 128px;
    left: -1px;
  }
  .emap-flow-center-header, .emap-flow-right-header {
    padding: 11px 8px 11px 16px;
    position: relative;
  }
  .emap-flow-center-body {
    padding-left: 14px;
    padding-right: 10px;
    height: calc(100% - 40px);
    overflow: hidden;
    border-color: transparent;
    background-color: transparent;
  }
  .emap-flow-center-body table th, .emap-flow-right-body table th {
    text-align: left;
  }
  .emap-flow-radio-list,.emap-flow-checkbox-list {
    height: 270px;
    overflow-y: auto
  }
  .emap-flow-radio-item:hover, .emap-flow-checkbox-item:hover {
    background-color: #DDEDFB;
  }
  .emap-flow-radio-list .ivu-radio-group-vertical .ivu-radio-wrapper {
    height: 24px;
    line-height: 24px;
  }
  .emap-flow-radio-list .ivu-radio-group-item {
    margin: 0;
  }
  .emap-flow-radio-list .emap-flow-radio-item>span,.emap-flow-radio-list .ivu-radio-group-item>span, .emap-flow-checkbox-item>span,.emap-flow-checked-list .emap-flow-checked-item>span {
    float: left;
    height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .emap-flow-radio-list .emap-flow-radio-item .ivu-radio, .emap-flow-checkbox-item .ivu-checkbox {
    width: 10%;
    margin-right: 0px;
    text-align: center;
  }
  .emap-flow-radio-list .emap-flow-radio-item span.ivu-radio+*, .emap-flow-checkbox-item .ivu-checkbox+span {
    margin: 0;
    padding-right: 2px; 
  }
  .emap-flow-radio-item .ivu-radio-group-item .ivu-radio-inner, .emap-flow-checkbox-item .ivu-checkbox-inner {
    top: 5px;
  }
  .emap-flow-checkbox-item .ivu-checkbox-disabled~span, .emap-flow-disabled {
    color: #ccc;
    cursor: not-allowed;
  }
  .emap-flow-checkbox-item {
    display: block;
  }
  .emap-flow-col3 {
    width: 30%;
    height: 24px;
  }
  .emap-flow-col4 {
    width: 25%;
  }
  .emap-flow-col1 {
    width: 10%;
  }
  .emap-flow-page {
    float: right;
    margin: 7px 10px;
  }
  .emap-flow-nodata {
    padding: 0 10px 0 14px;
    color: rgb(153, 153, 153);
  }
  .emap-flow-right-body {
    padding-left: 14px;
    padding-right: 10px;
  }
  .emap-flow-checked-list {
    height: 308px;
    overflow-y: auto;
  }
  .emap-flow-checked-item {
    height: 24px;
    line-height: 24px;
  }
</style>